<template>
	<div
		class="g-block-image-header"
		:class="{
			'g-block-image-header--edit': editable,
			'is-active': editable && active,
			'g-block-image-header--h5': h5,
		}"
		@click="onWrapClick"
	>
		<HeaderImagesPreview
			:items="imageData.items"
			:image-style="imageData.imageStyle"
			:display-mode="imageData.displayMode"
			:previewable="isPreviewable"
			@preview="onPreview"
		/>

		<ImageGalleryLightbox
			v-model:visible="lightboxVisible"
			:urls="lightboxUrls"
			:initial-index="lightboxIndex"
		/>
	</div>
</template>

<script>
	import HeaderImagesPreview from '../../../components/HeaderImagesPreview.vue';
	import ImageGalleryLightbox from '../../../components/ImageGalleryLightbox.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';
	import { normalizeImageHeaderData } from '../../../utils/imageHeader.js';

	export default {
		name: 'GBlockImageHeader',
		components: { HeaderImagesPreview, ImageGalleryLightbox },
		props: imageBlockProps,
		emits: imageBlockEmits,
		data() {
			return {
				lightboxVisible: false,
				lightboxUrls: [],
				lightboxIndex: 0,
			};
		},
		computed: {
			imageData() {
				return normalizeImageHeaderData(this.data);
			},
			isPreviewable() {
				return this.h5 && !this.editable;
			},
		},
		methods: {
			onWrapClick() {
				if (this.editable) {
					this.$emit('select');
				}
			},
			onPreview(index) {
				if (!this.isPreviewable) return;
				const urls = (this.imageData.items || [])
					.map(item => item?.previewUrl)
					.filter(Boolean);
				if (!urls.length) return;
				this.lightboxUrls = urls;
				this.lightboxIndex = Math.min(Math.max(0, index || 0), urls.length - 1);
				this.lightboxVisible = true;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-image-header {
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}
</style>
